import { api_GET_External, api_POST } from "./_api.js";

const cep_api =
{
    get: function (cep) {
        const promise = new Promise((resolve, reject) => {
            api_GET_External(`https://viacep.com.br/ws/${cep.replace("-", "")}/json/`).then(result => {
                if (result.data.erro)
                    reject({ message: "CEP não encontrado" });
                resolve(result);
            }).catch(e => {
                reject(e);
            });
        });

        return promise;
    },
    GeoCode: function (endereco) {
        const promise = new Promise((resolve, reject) => {
            api_POST("GeoCode", endereco)
                .then(result => resolve(result))
                .catch(e => reject(e));
        })
        return promise;
    }
}

export default cep_api
